import React from "react";
import ReactGA from "react-ga4";

const OutboundLink = ({ url, to, eventLabel, onClick, children, ...rest }) => {
  const href = url || to;
  const handleClick = (e) => {
    ReactGA.event({
      category: "Outbound Link",
      action: "click",
      label: eventLabel || href,
    });
    if (onClick) onClick(e);
  };
  return (
    <a href={href} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
};

export default OutboundLink;
